import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';


import { AppComponent } from './app.component';
import {RoutingModule} from './routing/routing.module';
import {HomeComponent} from './pages/home/home.component';
import {ScrollPositionService} from './services/scroll-position.service';
import {KenticoService} from './services/kentico.service';
import { NavMenuComponent } from './parts/nav-menu/nav-menu.component';
import {ServicesComponent} from './pages/services/services.component';
import {FinalActionComponent} from './parts/final-action/final-action.component';
import {TeamComponent} from './pages/team/team.component';
import {CallbackService} from './services/callback.service';
import {ContactComponent} from './pages/contact/contact.component';
import {FormsModule} from '@angular/forms';

import {HttpClientModule} from '@angular/common/http';
import {WorkListComponent} from './pages/work-list/work-list.component';
import {WorkDetailComponent} from './pages/work-detail/work-detail.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    TeamComponent,
    WorkListComponent,
    WorkDetailComponent,
    ContactComponent,
    ServicesComponent,
    NavMenuComponent,
    FinalActionComponent,
  ],
  imports: [
    BrowserModule,
    RoutingModule,
    FormsModule,
    HttpClientModule,
  ],
  providers: [ScrollPositionService, KenticoService, CallbackService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /opt/build/repo/src/app/app.module.ts